import { NavLink } from "react-router-dom";

type NavItemProps = {
  to: string;
  label: string;
};

export function NavItem({ to, label }: NavItemProps) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `hw-nav__item${isActive ? " hw-nav__item--active" : ""}`
      }
      end
    >
      {label}
    </NavLink>
  );
}
